import React, { useState, useEffect } from "react";
import { Map, Marker } from "pigeon-maps";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const LocationPicker = ({ onLocationSelect, initialPos, height = 350 }: any) => {
  const [center, setCenter] = useState<[number, number]>(initialPos || [27.7172, 85.324]);


  useEffect(() => {
    if (initialPos) {
      setCenter(initialPos);
    }
  }, [initialPos]);

return (
    <div 
      className={tw`w-full rounded-md border border-gray-300 overflow-hidden relative shadow-sm`}
      style={{ height: `${height}px` }} 
    >
      <Map 
        height={height} 
        center={center} 
        zoom={15} 
        onBoundsChanged={({ center }) => setCenter(center)}
        onClick={({ latLng }) => onLocationSelect?.(latLng[0], latLng[1])}
      >
        <Marker width={40} anchor={initialPos || center} color="#3b82f6" />
      </Map>
    </div>
  );
};

export default LocationPicker;